import { colorConstants } from 'config/colorConstants';
import React, { FC } from 'react';
import { PricingSimulatorStatusType } from 'utils/Enums';

type Props = {
    type?: 'default' | 'inProgress' | 'success' | 'error';
    items: [string, string, string, string];
    status?: PricingSimulatorStatusType;
};

const bgTextTypeColorMapping = {
    default: [colorConstants.greyAlt8, colorConstants.greyAlt7, colorConstants.limeGreen], //[background,font-color]
    inProgress: [colorConstants.blueAlt, colorConstants.white, colorConstants.limeGreen], //[background,font-color]
    success: [colorConstants.limeGreen, colorConstants.white, colorConstants.white], //[background,font-color]
    error: [colorConstants.red, colorConstants.white, colorConstants.white], //[background,font-color]
};

const Footer: FC<Props> = ({ type = 'default', items, status }) => {
    const colorMapping = bgTextTypeColorMapping[type];
    return (
        <div
            style={{ background: colorMapping[0], color: colorMapping[1] }}
            className="flex rounded-b-[3px] z-10  font-xxs h-[32px] px-4 font-semibold items-center justify-between gap-4"
        >
            <div className="flex gap-10">
                <p>{items[0]}</p>
                <p>{items[1]}</p>
            </div>
            <div className="flex gap-10">
                {status && (
                    <p>
                        Status: <span style={{ color: bgTextTypeColorMapping[type][2] }}>{status}</span>
                    </p>
                )}
                <p>{items[2]}</p>
                <p>{items[3]}</p>
            </div>
        </div>
    );
};

export default Footer;
